export * as ContentfulCTA from './Contentful/ctas'
export * as ContentfulHeroVideo from './Contentful/Hero/video'
export * as ContentfulImageAPI from './Contentful/image'

export const microcopyTransform = (microcopyArray: any[], text: string) => {
  if (!microcopyArray) return text
  try {
    return text.replace(/{{(.*?)}}/g, (match, p1) => {
      const microcopy = microcopyArray.find((edge: any) => edge.node.key === p1)
      return microcopy?.node?.content || match
    })
  } catch (exception) {}
  return text
}
